import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

export default [
  {
    path: '/advisor/investment-setup/:section?',
    name: 'InvestmentSetup',
    component: () => import('@advisor/components/settings/investmentSetup/InvestmentSetup'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Investment Setup',
        componentId: COMPONENT_ID.INVESTMENT_SETUP,
      },
      platformArea: PLATFORM_AREA.INVESTMENT_SETUP,
      riaComponent: RIA_COMPONENT.INVESTMENT_SETUP,
      visibilityComponentId: COMPONENT_ID.INVESTMENT_SETUP,
    },
  },
];
